import { combineReducers } from "redux";
import auth from "./auth/reducers";
import authTypes from "./auth/actionsTypes";
import clusterlets from "./constructs/clusterlets/reducer";
import transactions from "./constructs/transactions/reducer";
import clusterletConnections from "./constructs/clusterlet_connections/reducer";
import bootloaders from "./constructs/bootloaders/reducer";
import messages from "./constructs/messages/reducer";
import networks from "./constructs/networks/reducer";
import rrdefs from "./constructs/routing_rules/reducer";
import user_triggers from "./constructs/user_triggers/reducer";
import sections from "./constructs/sections/reducer";
import fields from "./constructs/fields/reducer";

import history from "./history/reducer";
import profile from "./profile/reducer";
import global from "./global/reducer";
import undoredo from './undoredo/reducer';

import events from "./constructs/events/reducer";
import handlers from "./constructs/handlers/reducer";
import utility_functions from "./constructs/utility_functions/reducer";
import schema from './views/reducer';
import templated_clusterlet from './constructs/templated_clusterlet/reducer';
import assets from './assets/reducer';


const constructs = combineReducers({
	clusterlets: clusterlets,
	transactions: transactions,
	clusterletConnections: clusterletConnections,
	events: events,
	bootloaders: bootloaders,
	messages: messages,
	networks: networks,
	rrdefs: rrdefs,
	user_triggers: user_triggers,
	sections: sections,
	fields: fields,
	handlers: handlers,
	utility_functions: utility_functions,
	templated_clusterlet: templated_clusterlet,
})

const appReducer = combineReducers({ auth, constructs, history, global, profile, undoredo, schema, assets });

const rootReducer = (state, action) => {
	if (action.type === authTypes.RESET_LOGIN) {
		return appReducer(undefined, action);
	}
	return appReducer(state, action);
};

export default rootReducer;

